module.exports = __webpack_public_path__ + "static/media/alert-add.a1b39e57.svg";